import type { FC, SVGProps } from 'react';

const MistIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5863 0.666016C5.61807 0.666016 3.20749 3.05344 3.17005 6.01276C1.85006 6.58922 0.886854 7.82893 0.701804 9.31293C0.644854 9.7696 0.968913 10.186 1.42561 10.2429C1.88231 10.2999 2.29871 9.97585 2.35566 9.5191C2.48384 8.49127 3.23905 7.65452 4.2267 7.40735C4.63219 7.30585 4.90539 6.91994 4.85902 6.49871C4.84401 6.36238 4.83627 6.22359 4.83627 6.08268C4.83627 4.01162 6.5152 2.33268 8.5863 2.33268C10.3162 2.33268 11.7746 3.50487 12.2064 5.09977C12.2927 5.41877 12.5574 5.65697 12.8822 5.71038C14.4633 5.97038 15.6696 7.34477 15.6696 8.99935C15.6696 9.11243 15.664 9.22393 15.6531 9.33368C15.6076 9.79168 15.9421 10.1998 16.4001 10.2453C16.8581 10.2908 17.2661 9.95635 17.3116 9.49835C17.328 9.33401 17.3363 9.16752 17.3363 8.99935C17.3363 6.69487 15.778 4.75573 13.6576 4.176C12.8862 2.12563 10.9076 0.666016 8.5863 0.666016ZM1.50289 12.3327C1.50289 11.8724 1.87599 11.4993 2.33622 11.4993H15.6696C16.1298 11.4993 16.5029 11.8724 16.5029 12.3327C16.5029 12.7929 16.1298 13.166 15.6696 13.166H2.33622C1.87599 13.166 1.50289 12.7929 1.50289 12.3327ZM4.83622 15.666C4.83622 15.2058 5.20932 14.8327 5.66955 14.8327H13.1696C13.6298 14.8327 14.0029 15.2058 14.0029 15.666C14.0029 16.1263 13.6298 16.4993 13.1696 16.4993H5.66955C5.20932 16.4993 4.83622 16.1263 4.83622 15.666Z"
        fill="#667180"
      />
    </svg>
  );
};

export default MistIcon;
